import { temporarilyNotSupport } from '../../utils'

// 广告
export const createRewardedVideoAd = /* @__PURE__ */ temporarilyNotSupport('createRewardedVideoAd')
export const createInterstitialAd = /* @__PURE__ */ temporarilyNotSupport('createInterstitialAd')
